import styled from 'styled-components'

import HorizontalRule from 'v2/components/UI/HorizontalRule'

export const ContextMenuDivider = styled(HorizontalRule).attrs({
  my: 2,
  color: 'gray.semiLight',
})``
